import config from "../../config";

export default {
  ...config,
  baseUrl: config.baseUrl || config.baseUrl,
};
